import React from 'react';
import PropTypes from 'prop-types';
import { Heading, RecaptchaCheckbox } from 'sarsaparilla';
import Modal from 'react-modal';

const propTypes = {
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func.isRequired,
    action: PropTypes.string,
    onRecaptchaChange: PropTypes.func,
    isSolved: PropTypes.bool,
};

const defaultProps = {
    isOpen: false
}

export class EnterpriseRecaptchaModal extends React.PureComponent {
    render() {
        const { action, closeModal, isOpen, onRecaptchaChange, isSolved } = this.props;
        return (
            <div>
                <Modal
                    isOpen={isOpen}
                    shouldCloseOnOverlayClick={false}
                    role="complementary"
                    className={{
                        base: 'rec-modal-dialog-base recaptcha-modal',
                        afterOpen: 'rec-modal-dialog-after-open-md recaptcha-modal',
                        beforeClose: 'rec-modal-dialog-before-close'
                    }}
                    overlayClassName={{
                        base: 'rec-overlay-base',
                        afterOpen: 'rec-overlay-after-open rec-overlay-after-open-recaptcha',
                        beforeClose: 'rec-overlay-before-close'
                    }}
                    contentLabel="Recaptcha"
                    ariaHideApp={false}>
                    <div className="rec-modal-content-wrap">
                        <Heading headingLevel={1} appearance="h4" className="rec-modal-title">
                            {`We need to verify that you’re a human`}
                        </Heading>
                        <div className="challenge-wrap">
                            <RecaptchaCheckbox
                                action={action}
                                size="normal"
                                onChange={onRecaptchaChange}
                                sitekey={process.env.RECAPTCHA_ENTERPRISE_KEY}
                            />
                        </div>
                    </div>
                    <div className="rec-modal-actions-wrap">
                        <button
                            className="rec-button-tertiary"
                            aria-label="Continue Booking"
                            onClick={closeModal}
                            disabled={!isSolved}>
                            Continue Booking
                        </button>
                    </div>
                </Modal>
            </div>
        )
    }
}

EnterpriseRecaptchaModal.propTypes = propTypes;
EnterpriseRecaptchaModal.defaultProps = defaultProps;
